import React from "react";
import { Route, Switch } from "react-router-dom"; 
import { ROUTES } from "../App";
import NotFound from "../pages/notFound/notFound.jsx";
import PrivateRoute from "../components/auth/privateRoute.js";

const ContentRouter = () => {
  return (
    <Switch>
      {ROUTES.map((route) => {
        const { key, path, exact, component, private: isPrivate } = route;
        if (isPrivate) {
          return (
            <PrivateRoute
              key={key}
              path={path}
              exact={exact}
              component={component}
            />
          );
        }
        return (
          <Route key={key} path={path} exact={exact} component={component} />
        );
      })}

      <Route exact path="/not-found" component={NotFound} />

      <Route component={NotFound} />
    </Switch>
  );
};

export default ContentRouter;
